import React, { useState, useEffect } from "react";
import {
  createCheckoutSession,
  getStripeRole,
  goToBillingPortal,
} from "../../config/Firebase";
import { useAuth } from "../../context/AuthContext";
import { CircularProgress } from "@material-ui/core";
import Button from '@material-ui/core/Button';

export const Pricing = () => {
  const { isAuth,activeUser,user } = useAuth();
  const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
  const [checkoutPeriod, setCheckoutPeriod] = useState('weekly');
  const [roleValue, setRoleValue] = useState(null);
  useEffect(() => {
    getStripeRole().then((result) => {
      setRoleValue(result);
    });
    
  }, []);

  useEffect(() => {
    if (isCheckoutLoading) {
      if (!isAuth) {
        window.location.assign('/login');
      } else
      if (roleValue !== "premium") {
        createCheckoutSession(activeUser.uid, checkoutPeriod);
      } else {
        goToBillingPortal();
      }
    }
    
  }, [isCheckoutLoading]);

  return (
    <section className="section-pricing">
      <div className="pt-5">
        <h2 className="text-center font-weight-bold mb-2">Pricing</h2>
        <h6 className="text-center text-danger font-weight-bold mb-3 text-capitalize">
          No Commitment, Cancel Anytime
        </h6>
      </div>
      <div className="bg-light-2 py-4">
        <div className="container-fluid">
          {isCheckoutLoading ? (
            <div><CircularProgress /> <p>Do not close the tab when loading.</p></div>
          ) : (
            <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 px-lg-5">
              {/* <div className="col p-4">
                <button
                  type="button"
                  className="btn card-size mx-auto text-left bg-white rounded-xl pricing-item p-3 d-flex flex-column align-items-center"
                >
                  <div className="text-center my-4">
                    <h5 className="font-weight-bold mb-2 text-center text-capitalize">
                      Weekly Trail
                    </h5>
                    <h5 className="font-weight-bold mb-2 text-center">
                      $3.99 / week
                    </h5>
                  </div>
                  <ul className="text-secondary text-capitalize mb-3">
                    <li>
                      <span className="small">Daily Market Summary</span>
                    </li>
                    <li>
                      <span className="small">Historical Market Summary</span>
                    </li>
                    <li>
                      <span className="small">UOA Feed</span>
                    </li>
                    <li>
                      <span className="small">Interactive Database</span>
                    </li>
                  </ul>
                  <div className="mt-auto text-center">
                    <Button
                      className="btn btn-sm btn-two rounded-pill px-3"
                      onClick={() => {
                        setIsCheckoutLoading(true);
                        setCheckoutPeriod("weekly");
                      }}
                    >
                      <small className="font-weight-bold">Get Started</small>
                    </Button>
                  </div>
                </button>
              </div>
              <div className="col p-4">
                <button
                  type="button"
                  className="btn card-size mx-auto text-left bg-white rounded-xl pricing-item p-3 d-flex flex-column align-items-center"
                >
                  <div className="badge badge-danger position-absolute px-2 py-1 pricing-item__tag">
                    Recommended
                  </div>
                  <div className="text-center my-4">
                    <h5 className="font-weight-bold mb-2 text-center text-capitalize">
                      Full Membership
                    </h5>
                    <h5 className="font-weight-bold mb-2 text-center">
                      <div>
                        <span>$9.99 / month</span>
                      </div>
                      <div>
                        <span>7 days free trial</span>
                      </div>
                    </h5>
                  </div>
                  <ul className="text-secondary text-capitalize mb-3">
                    <li>
                      <span className="small">Daily Market Summary</span>
                    </li>
                    <li>
                      <span className="small">Historical Market Summary</span>
                    </li>
                    <li>
                      <span className="small">UOA Feed</span>
                    </li>
                    <li>
                      <span className="small">Interactive Database</span>
                    </li>
                  </ul>
                  <div className="mt-auto text-center">
                    <Button
                      className="btn btn-sm btn-two rounded-pill px-3"
                      onClick={() => {
                        setIsCheckoutLoading(true);
                        setCheckoutPeriod("monthly");
                      }}
                    >
                        <small className="font-weight-bold">Get Started</small>
                    </Button>
                  </div>
                </button>
              </div> */}
              <div className="col p-4">
                <button
                  type="button"
                  className="btn card-size mx-auto text-left bg-white rounded-xl pricing-item p-3 d-flex flex-column align-items-center"
                >
                  <div className="badge badge-danger position-absolute px-2 py-1 pricing-item__tag">
                    Recommended
                  </div>
                  <div className="text-center my-4">
                    <h5 className="font-weight-bold mb-2 text-center text-capitalize">
                      Full Membership
                    </h5>
                    <h5 className="font-weight-bold mb-2 text-center">
                      <div>
                        <span>$1200 / year</span>
                      </div>
                      {/* <div> */}
                        {/* <span>7 days free trial</span> */}
                      {/* </div> */}
                    </h5>
                  </div>
                  <ul className="text-secondary text-capitalize mb-3">
                    <li>
                      <span className="small">Daily Market Summary</span>
                    </li>
                    <li>
                      <span className="small">Historical Market Summary</span>
                    </li>
                    <li>
                      <span className="small">UOA Feed</span>
                    </li>
                    <li>
                      <span className="small">Dark Pool Feed</span>
                    </li>
                    <li>
                      <span className="small">Penny stock alert</span>
                    </li>
                    <li>
                      <span className="small">Option trading alert</span>
                    </li>
                    <li>
                      <span className="small">Interactive Database</span>
                    </li>
                    {/* <li>
                    <span className='small'>
                      Daily UOA data files send to you
                    </span>
                  </li>
                  <li>
                    <span className='small'>
                      Full access to Historical database files
                    </span>
                  </li> */}
                  </ul>
                  <div className="mt-auto text-center">
                    <Button
                      className="btn btn-sm btn-two rounded-pill px-3"
                      onClick={() => {
                        setIsCheckoutLoading(true);
                        setCheckoutPeriod("yearly");
                      }}
                    >
                        <small className="font-weight-bold">Get Started</small>
                    </Button>
                  </div>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
